<template>
    <div>
        <div class="row">
            <div class="col-12 col-md-6 my-2">
                <label for="address">
                    {{ $t("label.address") }}
                </label>
                <select
                        v-if="addresses"
                        id="address"
                        name="address"
                        v-model="form_data.address"
                        class="form-control kt-selectpicker"
                >
                    <option
                            v-bind:key="address.id"
                            v-for="address in addresses"
                            :value="address.id"
                    >
                        {{ address.address }}
                    </option>
                </select>
            </div>
            <div class="col-12 col-md-6 my-2">
                <label for="telephone">
                    {{ $t("label.telephone") }}
                </label>
                <input
                        dir="ltr"
                        id="telephone"
                        class="form-control"
                        name="telephone"
                        v-model="form_data.telephone"
                />
            </div>
           
            <div class="col-12 col-md-6 my-2">
                <label for="sheba_number">
                    {{ $t("label.sheba_number") }}
                </label>
                <select
                        id="sheba_number"
                        name="sheba_number"
                        v-model="form_data.sheba"
                        class="form-control kt-selectpicker"
                >
                    <option
                            class="en_num"
                            v-bind:key="sheba_number.id"
                            v-for="sheba_number in sheba_numbers"
                            :value="sheba_number.id"
                    >
                        {{ sheba_number.number }}
                    </option>
                </select>
            </div>
            <div class="col-12 col-md-6 my-2">
                <label for="phone_number">
                    {{$t('label.phone_number') }}
                </label>
                <input
                        dir="ltr"
                        id="phone_number"
                        class="form-control"
                        name="phone_number"
                        v-model="form_data.phone_number"
                />
            </div>
        </div>

        <div class="d-flex align-items-center px-3 mt-4">
            <div>
                <button
                        type="button"
                        @click="step_back()"
                        class="btn btn-success px-4"
                        style="border-radius: 10px"
                >
                    <span>مرحله قبل</span>
                </button>
            </div>
            <div class="mr-auto">
                <button
                        v-if="wizard.submit_in_progress"
                        type="button"
                        disabled
                        class="btn btn-success px-4"
                        style="border-radius: 10px"
                >
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="mx-2">لطفا صبر کنید</div>
                        <div class="spinner-border spinner-border-sm text-white" role="status"></div>
                    </div>
                </button>
                <button
                        v-else
                        type="submit"
                        class="btn btn-success px-4"
                        style="border-radius: 10px"
                >
                    <span>ثبت درگاه</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {subcategories} from "@/constants/subcategories";
    import {mapGetters} from "vuex";
    import {userTypes} from '@/constants/userTypes';
    import {birthCrtfctSeriesLetters} from '@/constants/birthCrtfctSeriesLetter'

    export default {
        props: {
            wizard: Object,
            form_data: Object,
        },
        computed: {
            ...mapGetters("shebaNumber", ["sheba_numbers"]),
            ...mapGetters("address", ["addresses"]),
            ...mapGetters('user', [
                'current_user',
            ]),
        },
        data() {
            return {
                user_types: userTypes,
                subcategories: subcategories,
                birthCrtfctSeriesLetters: birthCrtfctSeriesLetters,
                etrust_certificate_types: [
                    {
                        key: 1,
                        value: this.$t('etrust_certificate_types.one')
                    },
                    {
                        key: 2,
                        value: this.$t('etrust_certificate_types.two')
                    },
                    {
                        key: 0,
                        value: this.$t('etrust_certificate_types.other')
                    },
                ],
            };
        },
        methods: {
            step_back() {
                this.wizard.current_step = 2;
            },
        },
    };
</script>

<style>
div #address-error{
    margin: 0.4rem -2rem;
}
div #sheba_number-error{
    margin: 0.4rem -2rem;
}
</style>